import React from 'react';
import { TextField } from '@mui/material';

interface SelectItem {
  value: string;
  label: string;
}
interface SelectInputProps extends Partial<React.ComponentProps<typeof TextField>> {
  selected: string;
  setSelected: (newVal: string) => void;
  list: SelectItem[];
  formatLabel?: (value: string) => string;
  fullWidth?: boolean;
  variant?: 'standard' | 'filled' | 'outlined';
  disabled?: boolean;
}

const SelectInput: React.FC<SelectInputProps> = ({
  selected,
  setSelected,
  list,
  formatLabel,
  fullWidth = false,
  variant = 'standard',
  disabled = false,
  ...rest
}) => {
  return (
    <TextField
      {...rest}
      type='text'
      value={selected}
      onChange={e => setSelected(e.target.value)}
      InputLabelProps={{ shrink: true }}
      select
      SelectProps={{ native: true }}
      fullWidth={fullWidth}
      variant={variant}
      disabled={disabled}
    >
      {list.map((item, index) => {
        let label = item.label;
        if (formatLabel) label = formatLabel(item.label);
        return (
          <option key={index} value={item.value}>
            {label}
          </option>
        );
      })}
    </TextField>
  );
};

export default SelectInput;
